// extracted by mini-css-extract-plugin
export var cardSelected = "_hr-2";
export var image = "_hr-1";
export var table = "_hr-0";